export default {
  state: {
    stats: {
      gross: 0,
      credits: 0,
      loading: false
    }
  },
  mutations: {
    setStats (state, data) {
      state.stats.gross = data.gross
      state.stats.credits = data.credits
    },
    setStatsLoading (state, value) { state.stats.loading = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/transactions/stats.js